"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoaderStyled = void 0;
const design_system_1 = require("@produits-internes-oss/design-system");
const styled_components_1 = __importDefault(require("styled-components"));
exports.LoaderStyled = styled_components_1.default.div `
&.octo {
  @keyframes fade {
    0% {
      opacity: 0;
    }

    100% {
      opacity: 1;
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  z-index: 999;
  display: flex;
  flex: 1;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  animation: 0.2s fade ease-in-out;

  >.spin {
    width: 4rem;
    height: 4rem;
    margin: 1rem;
    border: 0.3em solid ${design_system_1.theme.colors.turquoise[50]};
    border-radius: 50%;

    >.spin-interior {
      box-sizing: content-box;
      width: 100%;
      height: 100%;
      margin: -0.3rem;
      border: 0.3em solid transparent;
      border-top-color: ${design_system_1.theme.colors.turquoise[100]};
      border-radius: 50%;
      animation: 1s spin linear infinite;
    }
  }
}
`;
//# sourceMappingURL=Loader.styled.js.map